'use strict';

import React, { PropTypes } from 'react/addons';
import AnalyticsSources from '../constants/AnalyticsSources';
import ZineStore from '../stores/ZineStore';
import UserStore from '../stores/UserStore';
import LightboxStore from '../stores/LightboxStore';
import NavigationStore from '../stores/NavigationStore';
import NavigationContextTypes from '../constants/NavigationContextTypes';
import ClassNameMixin from '../mixins/ClassNameMixin';
import BackColorMixin from '../mixins/BackColorMixin';
import ScreenSizeMixin from '../mixins/ScreenSizeMixin';
import PureRenderMixin from '../mixins/PureRenderMixin';
import createStoreMixin from '../mixins/createStoreMixin';
import StampNavHeader from '../molecules/StampNavHeader';
import DraftPreviewNavHeader from '../molecules/DraftPreviewNavHeader';
import HomeNavHeader from '../molecules/HomeNavHeader';
import ZineNavHeader from '../molecules/ZineNavHeader';
import UserNavHeader from '../molecules/UserNavHeader';
import SearchNavHeader from '../molecules/SearchNavHeader';
import Link from '../atoms/Link';
import Counter from '../atoms/Counter';
import UserImage from '../atoms/UserImage';
import Icon from '../atoms/Icon';
import ContextMenuActionCreators from '../actions/ContextMenuActionCreators';
import ContextMenuTypes from '../constants/ContextMenuTypes';
import ModalTypes from '../constants/ModalTypes';
import ModalActionCreators from '../actions/ModalActionCreators';
import StampActionCreators from '../actions/StampActionCreators';
import Button from '../atoms/Button';
import BtnGroup from '../molecules/BtnGroup';
import SmoothScrollMixin from '../mixins/SmoothScrollMixin';
import SidebarActionCreators from '../actions/SidebarActionCreators';
import SidebarTypes from '../constants/SidebarTypes';
import ActivityActionCreators from '../actions/ActivityActionCreators';
import ActivityListStore from '../stores/ActivityListStore';
import RouterStateMixin from '../mixins/RouterStateMixin';
import Colors from '../constants/Colors';
import ZinesNavHeader from '../molecules/ZinesNavHeader';
import config from 'config';


require('./NavBar.less');

let UNSEEN_ACTIVITY_POLL_INTERVAL = 5000 * 9;

if (process.env.NODE_ENV !== 'production') {
  UNSEEN_ACTIVITY_POLL_INTERVAL *= 10;
}

function rgba(color, alpha) {
  const rgb = BackColorMixin.parseColor(color);
  return 'rgba(' + rgb.concat([alpha]).join(', ') + ')';
}

const Separator = React.createClass({
  mixins: [PureRenderMixin],

  propTypes: {
    hidden: PropTypes.bool
  },

  statics: {
    IS_SEPARATOR: true
  },

  render: function () {
    let style;
    if (this.props.hidden) {
      style = { opacity: 0 };
    }

    return (
      <div className='NavBar-separator'
           style={style} />
    );
  }
});

const NavBar = React.createClass({
  mixins: [
    ClassNameMixin,
    BackColorMixin,
    SmoothScrollMixin,
    RouterStateMixin,
    PureRenderMixin,
    ScreenSizeMixin,
    createStoreMixin(
      NavigationStore,
      UserStore,
      ZineStore,
      LightboxStore,
      ActivityListStore
    )
  ],

  contextTypes: {
    router: PropTypes.func
  },

  getStateFromStores() {
    const navContext = NavigationStore.getContext();
    const state = {
      me: UserStore.getMe(),
      navContext: navContext,
      isLightboxActive: LightboxStore.isActive(),
      unseenCount: ActivityListStore.getUnseenCount()
    };

    if (navContext && navContext.zineSlug) {
      state.zine = ZineStore.get(navContext.zineSlug);
    }

    return state;
  },

  getCSSModifiers() {
    var { navContext, isLightboxActive } = this.state;

    if (!navContext) {
      return [];
    }

    const modifiers = [];

    if (navContext.isScrolled) {
      modifiers.push('scrolled');
    }

    if (navContext.isAboutCover) {
      modifiers.push('aboutCover');
    }

    if (isLightboxActive ||
        navContext.isAboutCoverVideo ||
        UserStore.isAuthenticated() && navContext.isScrollingDown && !navContext.hasScrolledToInfo) {

      modifiers.push('hidden');
    }

    switch (navContext.id) {
    case NavigationContextTypes.ABOUT:
      modifiers.push('about');
      break;
    case NavigationContextTypes.STAMP:
      modifiers.push('stamp');
      break;
    case NavigationContextTypes.ZINE:
      modifiers.push('zine');
      break;
    case NavigationContextTypes.USER:
      modifiers.push('user');
      break;
    case NavigationContextTypes.HOME:
      modifiers.push('home');
      break;
    case NavigationContextTypes.DRAFT_COMPOSE:
      modifiers.push('draftCompose');
      break;
    case NavigationContextTypes.DRAFT_PREVIEW:
      modifiers.push('draftPreview');
      break;
    case NavigationContextTypes.SEARCH:
      modifiers.push('search');
      break;
    case NavigationContextTypes.ZINES:
      modifiers.push('zines');
      break;
    }

    return modifiers;
  },

  componentDidMount() {
    if (UserStore.isAuthenticated()) {
      ActivityActionCreators.requestUnseenCount();

      this.unseenInterval = setInterval(() => {
        ActivityActionCreators.requestUnseenCount();
      }, UNSEEN_ACTIVITY_POLL_INTERVAL);
    }
  },

  componentWillUnmount() {
    clearInterval(this.unseenInterval);
  },

  getColorsFromContext(navContext) {
    const isMobile = this.state.isMobile;
    const isTablet = this.state.isTablet;

    if (!navContext) {
      return {
        backColor: Colors.GRAY_LIGHT,
        isTextDark: true
      };
    }

    switch (navContext.id) {
    case NavigationContextTypes.DRAFT_COMPOSE:
      if (isMobile) {
        return {
          backColor: Colors.WHITE,
          isTextDark: true
        };
      }

      return {
        backColor: 'transparent',
        isTextDark: false
      };

    case NavigationContextTypes.ZINE:
      if (this.state.zine && (navContext.isScrolled || isMobile)) {
        return this.getColorsFromZine(this.state.zine);
      }

      return {
        backColor: 'transparent',
        isTextDark: false
      };

    case NavigationContextTypes.ABOUT:
      if (isMobile || isTablet) {
        return {
          backColor: Colors.WHITE,
          isTextDark: true
        };
      }

      return {
        backColor: 'transparent',
        isTextDark: false
      };

    default:
      return {
        backColor: rgba(Colors.WHITE, 0.97),
        isTextDark: true
      };
    }
  },

  getColorsFromZine(zine) {
    const backColor = zine.backColor;
    const color = this.getTextColor(backColor);

    return {
      backColor: rgba(backColor, 0.95),
      isTextDark: color === 'dark'
    };
  },

  render() {
    const { me, navContext } = this.state;
    const header = this.renderHeader(navContext);
    const colors = this.getColorsFromContext(navContext);
    const childColor = colors.isTextDark ? 'dark' : 'light';
    const isInHome = navContext && navContext.id === NavigationContextTypes.HOME;
    const isInDraftCompose = navContext && navContext.id === NavigationContextTypes.DRAFT_COMPOSE;
    const isHeaderContentHidden = this.isHeaderContentHidden(navContext);
    const isMobile = this.state.isMobile;
    const isTablet = this.state.isTablet;
    const { router: { makeHref } } = this.context;

    return (
      <div className={this.getClassName()}
           style={{
             backgroundColor: colors.backColor,
             color: colors.isTextDark ? Colors.DARK : Colors.LIGHT
           }}>

        <div className='NavBar-row'>
          <div className='NavBar-container NavBar-container--fillParent'>
            <div className='NavBar-logo'>
              <Link to='home'
                    className='NavBar-logoLink'
                    title='Stampsy'
                    context='Logo'
                    underline='never'
                    href={makeHref('home')}
                    onClick={this.handleHomeClick}
                    displayBlock>
                <Icon name='logo'
                      size='medium' />
                <span className='NavBar-logoHome'>
                  Home
                </span>
              </Link>
            </div>

            {header && !isMobile &&
              <NavBar.Separator hidden={isHeaderContentHidden} />
            }

            {header && !isMobile &&
              <div className='NavBar-header'>
                {header}
              </div>
            }
          </div>

          <div className='NavBar-container NavBar-container--inflexible'>
            {!isInDraftCompose &&
              this.renderSearchButton(childColor)
            }

            {!isInDraftCompose && <NavBar.Separator />}

            {!isInDraftCompose &&
              <BtnGroup>
                {!isTablet && !isMobile && me &&
                  <Button size='small'
                          color={isInHome ? 'green' : childColor}
                          fill={isInHome}
                          onClick={this.handleCreateClick}>
                    Create
                  </Button>
                }

                {me ?
                  this.renderActivityButton(childColor) :
                  this.renderLogin(childColor)
                }

                {me &&
                  <Button size='small'
                          color={childColor}
                          onClick={this.handleUserClick}
                          round>
                    <UserImage user={me}
                               size='small'
                               context='NavBar' />
                  </Button>
                }
              </BtnGroup>
            }
          </div>
        </div>

        {header && isMobile && !isHeaderContentHidden &&
          <div className='NavBar-row'>
            <div className='NavBar-container'>
              <div className='NavBar-header'>
                {header}
              </div>
            </div>
          </div>
        }
      </div>
    );
  },

  renderActivityButton(buttonColor) {
    const { unseenCount } = this.state;

    return (
      <Button className='NavBar-activities'
              context='NavBar'
              size='small'
              color={unseenCount > 0 ? 'red' : buttonColor}
              onClick={this.handleActivitiesClick}
              fill={!!unseenCount}
              round>

        {unseenCount > 0 &&
          <Counter context='NavBar'
                   count={unseenCount} />
        }

        {unseenCount === 0 &&
          <Icon name='notification'
                mode='stroke'
                size='small' />
        }
      </Button>
    );
  },

  renderSearchButton(buttonColor) {
    return (
      <Button context='NavBar'
              size='small'
              color={buttonColor}
              onClick={this.handleSearchClick}
              round>
        <Icon name='search'
              mode='stroke'
              size='small' />
      </Button>
    );
  },

  renderLogin(buttonColor) {
    const { navContext } = this.state;
    const showSignup = (!navContext || !navContext.isAboutCover) && config.signUpEnabled;

    return (
      <div className='NavBar-login'>
        <BtnGroup>
          {!showSignup &&
            <Button size='small'
                    color={buttonColor}
                    onClick={this.handleLoginClick}>
              Log In
            </Button>
          }

          {showSignup &&
            <Button size='small'
                    color='green'
                    onClick={this.handleSignupClick}
                    fill>
              Sign Up
            </Button>
          }
        </BtnGroup>
      </div>
    );
  },

  isHeaderContentHidden(navContext) {

    // Special cases: hide separator while nav header has no visible text.
    // We could return null from renderHeader(), but we want to keep the animation.

    switch (navContext && navContext.id) {
    case NavigationContextTypes.USER:
      return !navContext.hasScrolledPastPublished;
    case NavigationContextTypes.SEARCH:
      return !navContext.hasScrolledPastZines;
    default:
      return false;
    }
  },

  renderHeader(navContext) {
    switch (navContext && navContext.id) {
    case NavigationContextTypes.STAMP:
      return (
        <StampNavHeader stampId={navContext.stampId}
                        primaryZineSlug={navContext.primaryZineSlug}
                        scrolledPastNextUp={navContext.hasScrolledPastNextUp}
                        nextUpTitle={navContext.nextUpTitle} />
      );

    case NavigationContextTypes.DRAFT_PREVIEW:
      return (
        <DraftPreviewNavHeader />
      );

    case NavigationContextTypes.ZINE:
      return (
        <ZineNavHeader zineSlug={navContext.zineSlug}
                       isEditing={navContext.isEditing} />
      );

    case NavigationContextTypes.USER:
      return (
        <UserNavHeader userId={navContext.userId}
                       scrolledPastPublished={navContext.hasScrolledPastPublished}
                       scrolledPastCurated={navContext.hasScrolledPastCurated}
                       scrolledPastLiked={navContext.hasScrolledPastLiked} />
      );

    case NavigationContextTypes.SEARCH:
      return (
        <SearchNavHeader scrolledPastZines={navContext.hasScrolledPastZines}
                         scrolledPastUsers={navContext.hasScrolledPastUsers}
                         scrolledPastStamps={navContext.hasScrolledPastStamps} />
      );

    case NavigationContextTypes.HOME:
      return (
        <HomeNavHeader scrolled={navContext && navContext.isScrolled} />
      );

    case NavigationContextTypes.ZINES:
      return (
        <ZinesNavHeader scrolled={navContext && navContext.isScrolled}
                        scrolledSectionId={navContext.scrolledSectionId} />
      );

    default:
      return null;
    }
  },

  handleUserClick(e) {
    const el = e.target;
    const user = UserStore.getMe();

    ContextMenuActionCreators.showContextMenu(ContextMenuTypes.USER_PROFILE, el, {
      userId: user.id
    });
  },

  handleCreateClick(e) {
    const el = e.target;
    const user = UserStore.getMe();

    ContextMenuActionCreators.showContextMenu(ContextMenuTypes.CREATE, el, {
      userId: user.id
    });
  },

  handleSearchClick() {
    const { router: { transitionTo, isActive } } = this.context;

    if (!isActive('search')) {
      transitionTo('search');
    }
  },

  handleLoginClick() {
    ModalActionCreators.showModal(ModalTypes.LOGIN, {
      source: AnalyticsSources.NAV_BAR
    });
  },

  handleSignupClick() {
    ModalActionCreators.showModal(ModalTypes.ABOUT, {
      source: AnalyticsSources.NAV_BAR
    });
  },

  handleHomeClick() {
    const { router: { transitionTo, isActive } } = this.context;

    if (isActive('feed')) {
      this.animateScroll(0, 200);
      StampActionCreators.requestFeedWithTrendingPage(true, true);
      return;
    }

    transitionTo('feed');
  },

  handleActivitiesClick() {
    SidebarActionCreators.showSidebar(SidebarTypes.ACTIVITIES);
  }
});

NavBar.Separator = Separator;

export default NavBar;



/** WEBPACK FOOTER **
 ** ./organisms/NavBar.jsx
 **/